import React, { useEffect, useState } from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import CTA from '../components/sections/CTA';
import { Users, TrendingUp, Globe, Award, MapPin, Target } from 'lucide-react';
import GTA    from '../assets/partners/gta.jpg';
import GHATOF from '../assets/partners/ghatof.jpg';
import TOSOGHA from '../assets/partners/tosogha.png';
import GTDC   from '../assets/partners/gtdc.jpg';
import HOTCATT from '../assets/partners/HOTCATT.png';
import MOT    from '../assets/partners/mot.jpg';
import CAA    from '../assets/partners/caa.jpeg';
import AHTEC  from '../assets/partners/AHTEC.jpeg';
import AKUNA  from '../assets/partners/AKUNA.png';
import UGBS from '../assets/partners/ugbs.png';
import { publicService } from '../api/services';

const VIDEO_URL = 'https://firebasestorage.googleapis.com/v0/b/images-1aaab.appspot.com/o/20546634-uhd_3840_2160_30fps.mp4?alt=media&token=43e2bb92-2523-416f-a0b3-a1c42a351537';

// const stats = [
//   { value: '2+',   label: 'Verified Experts' },
//   { value: '5.0★', label: 'Average Rating' },
//   { value: '2+',   label: 'Sessions Completed' },
//   { value: 'GTA',  label: 'Accredited' },
// ];

const values = [
  { icon: Target,    title: 'Our Mission',   desc: 'To democratise access to world - class expertise, empowering every entrepreneur to build a thriving enterprise.' },
  { icon: Globe,     title: 'Our Vision',    desc: 'A world where every entrepreneur can connect with a verified expertise and unlock their full business potential.' },
  { icon: Award,     title: 'Our Standards', desc: 'The Profile of every expert on TourEnt Hub is reviewed and approved by our team of experts. We verify qualifications, experience and professional background before any expert goes live on the platform.' },
  { icon: Users,     title: 'Our Community', desc: 'We are building a dedicated business community - a space where budding and experienced entrepreneurs, experts and industry players collaborate, learn and grow together.' },
  { icon: TrendingUp,title: 'Our Impact',    desc: 'Our structured level system guides entrepreneurs from startup to scale - covering business planning, marketing, operations and international expansion.' },
  // { icon: MapPin,    title: 'Our Home',      desc: 'Born in Accra, designed for the world. We partner with leading industry bodies including GTA, HOTCATT, GHATOF, TOSOGHA and more.' },
];

const team = [
  { name: 'GTDC',                 role: 'Industry Partner',  src: GTDC },
  { name: 'GTA',                  role: 'Strategic Partner', src: GTA },
  { name: 'Ministry of Tourism',  role: 'Government Body',   src: MOT },
  { name: 'HOTCATT',              role: 'Industry Partner',  src: HOTCATT },
  { name: 'Creative Arts Agency', role: 'Industry Partner',  src: CAA },
  { name: 'GHATOF',               role: 'Industry Partner',  src: GHATOF },
  { name: 'TOSOGHA',              role: 'Industry Partner',  src: TOSOGHA },
  { name: 'AHTEC',                role: 'Industry Partner',  src: AHTEC },
  { name: 'The Akuna Group',      role: 'Industry Partner',  src: AKUNA },
  { name: 'UGBS',                 role: 'Academic Partner',  src: UGBS },
];

const AboutPage = () => {
  const [videoReady, setVideoReady] = useState(false);
  const [platformStats, setPlatformStats] = useState(null);

  useEffect(() => {
    publicService.getStats()
      .then(res => setPlatformStats(res.data?.data ?? res.data))
      .catch(() => {});
  }, []);

  const stats = [
    {
      value: platformStats ? `${platformStats.experts}+` : '—',
      label: 'Verified Experts',
    },
    // {
    //   value: platformStats?.avgRating ? `${platformStats.avgRating}★` : '—',
    //   label: 'Average Rating',
    // },
    {
      value: platformStats ? `${platformStats.sessions}+` : '—',
      label: 'Sessions Completed',
    },
    // {
    //   value: 'GTA',
    //   label: 'Accredited',
    // },
  ];


  return (
    <div className="min-h-screen bg-cream-50">
      <Navbar />

      {/* ── Video Hero ── */}
      <div className="relative" style={{ minHeight: 380 }}>
        <video
          autoPlay muted loop playsInline
          className="absolute inset-0 w-full h-full object-cover transition-opacity duration-1000"
          style={{ zIndex: 0, opacity: videoReady ? 1 : 0 }}
          onCanPlay={() => setVideoReady(true)}
        >
          <source src={VIDEO_URL} type="video/mp4" />
        </video>
        {!videoReady && (
          <div className="absolute inset-0" style={{ zIndex: 0, background: '#0a1e0d' }} />
        )}
        <div className="absolute inset-0"
          style={{ zIndex: 1, background: 'linear-gradient(160deg, rgba(2,10,5,0.82) 0%, rgba(3,14,7,0.78) 50%, rgba(1,8,3,0.88) 100%)' }} />
        <div className="absolute top-0 left-0 right-0 h-[3px]"
          style={{ zIndex: 2, background: 'linear-gradient(90deg, #dc2626, #d97706, #16a34a, #d97706, #dc2626)' }} />

        <div className="relative z-10 pt-32 pb-20 px-6">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-[11px] font-semibold uppercase tracking-widest mb-6"
              style={{ background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.15)', color: 'rgba(255,255,255,0.7)' }}>
              <span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse" />
              About TourEnt Hub
            </div>
            <h1 className="font-serif text-4xl lg:text-6xl font-semibold text-white leading-tight mb-6">
              <span className="italic font-light text-green-300">Entrepreneurship Hub</span>
            </h1>
            <p className="text-white/55 text-lg leading-relaxed max-w-2xl mx-auto">
              We connect entrepreneurs across the world with verified industry experts through
              live video, audio and chat sessions — guided by a structured learning pathway from
              startup to scale.
            </p>
          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0 h-16"
          style={{ zIndex: 3, background: 'linear-gradient(to bottom, transparent, #f8f6f0)' }} />
      </div>

      {/* Stats */}
      <div className="bg-white border-b border-cream-200">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 py-10">
          <div className="grid grid-cols-2 sm:grid-cols-2 gap-8">
            {stats.map((s, i) => (
              <div key={i} className="text-center">
                <div className={`font-serif text-3xl font-bold text-forest-900 transition-all duration-300 ${
                  !platformStats && s.value === '—' ? 'animate-pulse text-forest-300' : ''
                }`}>
                  {s.value}
                </div>
                <div className="text-xs text-forest-500 font-medium mt-1 uppercase tracking-widest">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Story */}
      <div className="max-w-4xl mx-auto px-6 lg:px-10 py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="section-label mb-5">Our Story</div>
            <h2 className="font-serif text-3xl lg:text-4xl font-semibold text-forest-900 leading-tight mb-5">
              Built for <br />
              <span className="italic text-forest-600">Entrepreneurs</span>
            </h2>
            <div className="space-y-4 text-forest-600 text-sm leading-relaxed">
              <p>
                Entrepreneurship is one of the most vibrant sectors on the continent, 
                yet significant number of people trying to build enterprises lack access to structured guidance, 
                verified expertise and a community of peers.
              </p>
              <p>
                Tourent Hub was created to change that. We have built a platform where entrepreneurs, 
                whether you are launching your first eco-lodge or scaling a creative show - can connect with vetted specialists and grow with confidence.
              </p>
              <p>
                Our structured level system takes you from the fundamentals of starting a business all the way to commercialisation, 
                profit optimisation and international expansion.
              </p>
            </div>
          </div>
          <div className="bg-forest-900 rounded-3xl p-8 space-y-4">
            {['Level 1 — Startup & Launch', 'Level 2 — Commercialization', 'Level 3 — Profit Optimization', 'Level 4 — Scale'].map((lvl, i) => (
              <div key={i} className="flex items-center gap-4">
                <div className="w-8 h-8 bg-forest-700 rounded-lg flex items-center justify-center text-gold-400 font-serif font-bold text-sm flex-shrink-0">
                  {i + 1}
                </div>
                <span className="text-cream-50 text-sm font-medium">{lvl.split('—')[1]?.trim()}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Values */}
      <div className="bg-cream-100/60 py-20">
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-14">
            <div className="section-label justify-center mb-4">What We Stand For</div>
            <h2 className="font-serif text-3xl lg:text-4xl font-semibold text-forest-900">
              Mission, Vision & <span className="italic text-forest-600">Values</span>
            </h2>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {values.map((v, i) => (
              <div key={i} className="bg-white border border-cream-200 rounded-2xl p-6 hover:shadow-sm transition-shadow">
                <div className="w-11 h-11 bg-forest-50 rounded-xl flex items-center justify-center mb-4">
                  <v.icon size={20} className="text-forest-600" />
                </div>
                <h3 className="font-serif font-semibold text-forest-900 text-lg mb-2">{v.title}</h3>
                <p className="text-sm text-forest-600 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Partners */}
      <div className="py-20 max-w-5xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-12">
          <div className="section-label justify-center mb-4">Our Partners</div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {team.map((t, i) => (
            <div key={i} className="bg-white border border-cream-200 rounded-2xl p-5 text-center hover:shadow-sm transition-shadow flex flex-col items-center gap-3">
              <img src={t.src} alt={t.name} className="h-14 w-auto object-contain rounded-lg" />
              <div>
                <div className="font-sans font-semibold text-forest-900 text-xs">{t.name}</div>
                <div className="text-[10px] text-forest-400 mt-0.5">{t.role}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <CTA />
      <Footer />
    </div>
  );
};

export default AboutPage;